import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initSentry } from './lib/sentry';

initSentry();
createRoot(document.getElementById('root') as HTMLElement, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler()
}).render((<App />) as any);
